export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  tags: string[];
  chapters: number;
  rating: number;
  status: string;
  desc: string;
  cover: string;
  views: string;
  updated: string;
}

export const comics: Comic[] = [
  {
    id: "blade-of-ember",
    title: "炎刃少年",
    author: "青岚",
    category: "热血冒险",
    tags: ["战斗", "成长", "热血"],
    chapters: 128,
    rating: 9.2,
    status: "连载中",
    desc: "少年刃司在废弃遗迹中拾到一把会说话的炎刃，从此踏上守护故土的冒险之路。",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20book%20cover%20illustration%2C%20energetic%20young%20hero%20with%20spiky%20dark%20hair%20wielding%20a%20glowing%20flame%20sword%2C%20bold%20ink%20lineart%2C%20cel%20shading%2C%20dramatic%20warm%20orange%20sunset%20background%2C%20japanese%20shonen%20manga%20style%2C%20dynamic%20composition%2C%20high%20contrast&width=720&height=1000&seq=cover-blade-2026&orientation=portrait",
    views: "1246万",
    updated: "今日更新",
  },
  {
    id: "sakura-homeroom",
    title: "樱花教室",
    author: "月白",
    category: "校园日常",
    tags: ["青春", "校园", "治愈"],
    chapters: 86,
    rating: 8.9,
    status: "连载中",
    desc: "转学生小林与几位性格迥异的同学，在樱花纷飞的教室里写下属于他们的青春故事。",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20book%20cover%20illustration%2C%20cheerful%20high%20school%20students%20walking%20together%20under%20cherry%20blossom%20trees%2C%20soft%20pastel%20palette%2C%20clean%20ink%20lineart%2C%20slice%20of%20life%20shonen%20manga%20style%2C%20warm%20spring%20light%2C%20no%20text&width=720&height=1000&seq=cover-sakura-2026&orientation=portrait",
    views: "873万",
    updated: "昨日更新",
  },
  {
    id: "moonlit-witch",
    title: "月语魔女",
    author: "苏黎",
    category: "奇幻冒险",
    tags: ["奇幻", "魔法", "冒险"],
    chapters: 64,
    rating: 9.0,
    status: "连载中",
    desc: "银发少女莉娅在暗色森林中遇见会发光的精灵，一场关于月亮的古老预言悄然苏醒。",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20book%20cover%20illustration%2C%20mysterious%20girl%20with%20long%20silver%20hair%20in%20a%20dark%20fantasy%20forest%20with%20glowing%20spirits%2C%20moody%20deep%20blue%20and%20violet%20palette%2C%20detailed%20ink%20lineart%2C%20fantasy%20manga%20style&width=720&height=1000&seq=cover-moon-2026&orientation=portrait",
    views: "651万",
    updated: "3天前更新",
  },
  {
    id: "neon-detective",
    title: "霓虹侦探",
    author: "顾北",
    category: "悬疑推理",
    tags: ["推理", "悬疑", "都市"],
    chapters: 45,
    rating: 9.3,
    status: "已完结",
    desc: "雨夜城市里，一名沉默的侦探凭借过人的洞察力，在霓虹光影中追查一桩桩离奇案件。",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20book%20cover%20illustration%2C%20detective%20silhouette%20in%20a%20rainy%20neon%20city%20street%2C%20noir%20atmosphere%2C%20strong%20chiaroscuro%20ink%20lineart%2C%20mystery%20manga%20style%2C%20rain%20reflections&width=720&height=1000&seq=cover-neon-2026&orientation=portrait",
    views: "932万",
    updated: "已完结",
  },
  {
    id: "sunroom-cat",
    title: "阳光房里的猫",
    author: "鹿鸣",
    category: "轻松治愈",
    tags: ["治愈", "日常", "萌宠"],
    chapters: 132,
    rating: 8.8,
    status: "连载中",
    desc: "一只傲娇的橘猫与安静的女孩在阳光房相遇，平凡日子里藏着最柔软的治愈。",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20book%20cover%20illustration%2C%20adorable%20fluffy%20orange%20cat%20and%20calm%20girl%20relaxing%20in%20a%20cozy%20sunlit%20room%20with%20green%20plants%2C%20warm%20cream%20and%20sage%20green%20palette%2C%20gentle%20ink%20lineart%2C%20healing%20slice%20of%20life%20manga&width=720&height=1000&seq=cover-cat-2026&orientation=portrait",
    views: "1105万",
    updated: "今日更新",
  },
  {
    id: "iron-pilot",
    title: "钢铁飞行者",
    author: "陈烬",
    category: "科幻机甲",
    tags: ["科幻", "机甲", "战斗"],
    chapters: 58,
    rating: 9.1,
    status: "连载中",
    desc: "少年飞行员驾驶巨型机甲，在未来的城市天际线上迎战来自轨道之外的神秘敌人。",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20book%20cover%20illustration%2C%20young%20pilot%20in%20a%20giant%20mecha%20robot%20on%20a%20futuristic%20city%20skyline%2C%20bright%20orange%20and%20teal%20accents%2C%20bold%20mechanical%20ink%20lineart%2C%20science%20fiction%20manga%20style&width=720&height=1000&seq=cover-iron-2026&orientation=portrait",
    views: "764万",
    updated: "2天前更新",
  },
  {
    id: "noodle-night",
    title: "深夜面馆",
    author: "北岛",
    category: "美食生活",
    tags: ["美食", "生活", "温馨"],
    chapters: 39,
    rating: 8.7,
    status: "连载中",
    desc: "深夜街角的温暖面馆，一碗热汤面里盛着形形色色的人生，治愈每一个晚归的人。",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20book%20cover%20illustration%2C%20steaming%20bowl%20of%20ramen%20with%20chopsticks%20in%20a%20lively%20street%20food%20stall%20at%20night%2C%20warm%20glowing%20lanterns%2C%20appetizing%20colors%2C%20detailed%20ink%20lineart%2C%20food%20manga%20style&width=720&height=1000&seq=cover-noodle-2026&orientation=portrait",
    views: "589万",
    updated: "4天前更新",
  },
  {
    id: "court-on-fire",
    title: "球场燃烧",
    author: "韩骁",
    category: "运动竞技",
    tags: ["体育", "篮球", "热血"],
    chapters: 102,
    rating: 9.0,
    status: "已完结",
    desc: "身高并不出众的少年凭借永不言弃的斗志，在篮球赛场上点燃属于自己的高光时刻。",
    cover: "https://readdy.ai/api/search-image?query=manga%20comic%20book%20cover%20illustration%2C%20determined%20basketball%20player%20mid%20dunk%20under%20bright%20stadium%20lights%2C%20dynamic%20action%20lines%2C%20energetic%20ink%20lineart%2C%20sports%20manga%20style&width=720&height=1000&seq=cover-court-2026&orientation=portrait",
    views: "1288万",
    updated: "已完结",
  },
];

export interface Category {
  id: string;
  name: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { id: "action", name: "热血冒险", icon: "ri-flashlight-fill", count: 268 },
  { id: "campus", name: "校园日常", icon: "ri-school-fill", count: 214 },
  { id: "fantasy", name: "奇幻冒险", icon: "ri-sparkling-2-fill", count: 187 },
  { id: "mystery", name: "悬疑推理", icon: "ri-search-eye-fill", count: 156 },
  { id: "healing", name: "轻松治愈", icon: "ri-heart-fill", count: 201 },
  { id: "scifi", name: "科幻机甲", icon: "ri-rocket-2-fill", count: 132 },
  { id: "food", name: "美食生活", icon: "ri-restaurant-fill", count: 98 },
  { id: "sports", name: "运动竞技", icon: "ri-football-fill", count: 121 },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "双页模式和滚动阅读有什么区别？怎么切换？",
    a: "双页模式适合平板和大屏，左右两页并排，像翻阅实体书一样翻页；滚动阅读适合手机竖屏，图片纵向连续加载，滑到哪里停在哪里。阅读页顶栏有切换按钮，随时可以自由切换，进度会自动同步。",
  },
  {
    q: "夜间模式怎么开启？",
    a: "在阅读页顶栏点击月亮图标即可一键切换夜间模式。夜间模式会降低屏幕亮度的刺激，采用深色护眼底，长时间追更也不容易眼疲劳。",
  },
  {
    q: "阅读进度会自动保存吗？",
    a: "会的。MGB漫画网会自动记录你的阅读位置，下一次打开作品时会直接跳到上次读到的地方，接着看不用重新翻找。",
  },
  {
    q: "换一台设备登录，阅读进度会同步吗？",
    a: "登录账号后，阅读进度会保存在你的账号下，换设备也能同步接续阅读。未登录时进度保存在当前设备本地，建议登录账号以享受多端同步。",
  },
  {
    q: "图片加载有点慢怎么办？",
    a: "可以在阅读设置里开启图片加速，MGB漫画网会对图片进行智能压缩与预加载，翻页时会提前加载后面的内容，让阅读过程更流畅不卡顿。",
  },
];